// extracted by mini-css-extract-plugin
export default {"root":"_11BN1","icon":"QLN_M"};